import React from 'react';
import RicercaSanzioneService from "./ricercaSanzioneService";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { URL,EASY_KEY } from './worldline.config';
import { toast, ToastContainer } from 'react-toastify'
import LoadSpinner from '../../common/spinner/loadSpinner';
import logoCompany from '../../assets/img/logo_APAM.svg';
import moment from "moment";

class RicercaSanzioneR extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          loading: true,
          sanzioni: [],
          sanzione: "",
          cercaSanzione: "",
          dataDiNascitaSanzionato: "",
          sanzioneTrovata: false,
          captcha:"",
          loadingButton:false,
          formData: {
            page:"",
            importo:"",
            valuta:"",
            idNegozio:"",
            numOrd:"",
            urlDone:"",
            urlBack:"",
            urlMS:"",
            tContab:"",
            tAutor:"",
            mac:""
          }
        };

        this.ricercaSanzioneService = new RicercaSanzioneService();
      }

      componentDidMount() {
        loadCaptchaEnginge(6);
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get("id");
        if(id!== null){
          this.setState({cercaSanzione: id});
        }
    
        // this.ricercaSanzioneService = new RicercaSanzioneService();
        // this.ricercaSanzioneService.getSanzioni(id, this.sanzione.bind(this));
      }

      onChangeCercaSanzione(event) {
        this.setState({ cercaSanzione: event.target.value });
      }

      onChangeDataDiNascitaSanzionato(event) {
        let value = event.target.value;
        console.log("Date: " + value);
        this.setState({ dataDiNascitaSanzionato: value});
      }

      onChangeCaptchaInput(event){
        this.setState({captcha: event.target.value});
      }

    //   sanzione(result) {
    //     this.setState({ sanzioni: result });
    //   }

      cercaSanzione() {
        if(validateCaptcha(this.state.captcha,true)){
            this.setState({ sanzione: "" });

            this.ricercaSanzioneService.searchSanzione(
              (result) => {
                this.setState({ sanzione: result.data });
                
                this.setState({cercaSanzione:""})
                
                document.getElementById("sanzioneTrovata").scrollIntoView()

              },
              () => {
                toast.error(`Nessuna sanzione trovata`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              },
              this.state.cercaSanzione,
              moment(this.state.dataDiNascitaSanzionato).toDate().getTime()
            );
            validateCaptcha("",true);
        }else{
          toast.error(`Captcha Errato`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }

        this.setState({captcha:""});

        if (this.state.sanzione === "") {
          this.setState({ sanzioneTrovata: true });
        } else {
          this.setState({ sanzioneTrovata: false });
        }
      }
       pagaSanzione(importo) {
        this.setState({loadingButton:true})
        this.ricercaSanzioneService.pagaSanzione(this.state.sanzione.numeroSanzione,importo,(result) => {
          console.log(result.data)
          if (result.status === 200 && result.data !== "") {
            window.location.href = result.data
          }else{
            this.setState({loadingButton:false})
            toast.error('Errore riprova piu tardi', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
        },(idSanzione)=>{
          this.setState({loadingButton:false})
          toast.error(`Errore n. ${idSanzione} riprova piu tardi`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        });
       }

      render(){
        const dataRilascio = new Date(this.state.sanzione.dataEmissione);
            var data =
            dataRilascio.toLocaleDateString("it-IT")
        return(
            <div className='container-fluid ' style={{minHeight: "80vh"}}>
              <ToastContainer/>
              <div className='row d-flex flex-md-row flex-column-reverse justify-content-between justify-content-md-center align-items-center text-center text-lg-start pt-3 pl-lg-5'>
              <h2 className='col-12 col-md-8 text-center'>RICERCA E PAGA UNA SANZIONE</h2>
              <img className='col-12 col-md-4' src={logoCompany} style={{height:"120px", width:"120px"}} alt='logo APAM'/>
                </div>
                <div className='row d-flex flex-column flex-lg-row p-lg-5 p-lg-0 p-4 gap-4 gap-lg-0 align-items-center justify-content-center'>
                <div className='col-10 mr-lg-5 col-lg-6 d-flex flex-column gap-5 align-items-center card h-100'>
                        <h3 className='pt-4'>Ricerca la tua sanzione</h3>
                        <div className='d-flex flex-column flex-lg-row gap-3'>
                            <label>N° Identificativo</label>
                            <input id="cercaSanzioneInput" className='form-control' type="text" value={this.state.cercaSanzione} onChange={this.onChangeCercaSanzione.bind(this)}
                            />
                        </div>
                        <div className='d-flex flex-column flex-lg-row gap-3'>
                            <label>Data di nascita sanzionato</label>
                            <input id="dataDiNascitaInput" className='form-control' type="date" value={this.state.dataDiNascitaSanzionato} placeholder="GG/MM/YYYY" onChange={this.onChangeDataDiNascitaSanzionato.bind(this)}
                            />
                        </div>
                        <div className='d-flex flex-column  gap-3 w-50 justify-content-center align-items-center'>
                            <LoadCanvasTemplate />
                            <input type="text" value={this.state.captcha} onChange={this.onChangeCaptchaInput.bind(this)}/>
                        </div>
                        <button
                            className="btn btn-primary mb-3"
                            onClick={this.cercaSanzione.bind(this)}
                            disabled={this.state.cercaSanzione.length < 5 || this.state.dataDiNascitaSanzionato === ""}>
                                CERCA
                                </button>
                    </div>
                    <div id='sanzioneTrovata' className='col-10 col-lg-4 d-flex flex-column justify-content-center ps-lg-5'>{this.state.sanzione === ""
                    ?<></>
                    :<div className='card d-flex flex-column py-3'>
                        <h5 className='card-title p-5 lh-lg'>N° Identificativo: <span className='fs-6'> {this.state.sanzione.numeroSanzione} </span></h5>
                        <div className='card-body'>
                            <h6 className="card-subtitle mb-2 text-muted p-3">Data Emissione: {data !=="1/1/1970"? data : ""}</h6>
                            {this.state.sanzione.importoDaPagareDue > 0 && <h6 className='text-danger'>Attenzione, Scegli l'importo in valutazione dalla data di notifica</h6>}
                        </div>
                        <div className='d-flex justify-content-center p-0 m-2 justify-content-lg-center gap-2'>
                        {this.state.sanzione.importoDaPagareTre > 0
                        ?<button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagareTre)}
                            disabled={!this.state.sanzione.importoDaPagareTre > 0 || this.state.loadingButton}
                        >
                             {this.state.loadingButton ? <LoadSpinner/>:"Paga € " + (this.state.sanzione.importoDaPagareTre / 100).toFixed(2)}
                        </button>
                        :""}
                        {this.state.sanzione.importoDaPagareDue > 0
                        ?<button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagareDue)}
                            disabled={!this.state.sanzione.importoDaPagareDue > 0 || this.state.loadingButton}
                        >
                             {this.state.loadingButton ? <LoadSpinner/>:"Paga € " + (this.state.sanzione.importoDaPagareDue / 100).toFixed(2)}
                        </button>
                        :""}
                        <button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagare)}
                            disabled={!this.state.sanzione.importoDaPagare > 0 || this.state.loadingButton}
                        >
                             {this.state.loadingButton ? <LoadSpinner/>:"Paga € " + (this.state.sanzione.importoDaPagare / 100).toFixed(2)}
                        </button>
                        </div>
                    </div>}

                    </div>
                </div>
                <p className='text-center' style={{fontSize:"0.7rem"}}> APAM ESERCIZIO S.P.A. - Sede legale: Via dei Toscani, 3/c, 46100 Mantova, C.P. 239 Mantova Centro - tel: 0376 2301 - fax: 0376 230330</p>
                <p className='text-center' style={{fontSize:"0.7rem"}}> P.IVA/C.F. e iscriz. Registro Imprese di Mn n. 02004750200 - numero REA: MN-215834 - apam@legalmail.it</p>
            </div>
        )
      }

}

export default RicercaSanzioneR;